"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addObjectToDataset = exports.addObjectValueToDataset = void 0;
var data_model_1 = require("@rdfjs/data-model");
var createSubjectHandler_1 = require("../createSubjectHandler");
function getIdNode(item, contextUtil) {
    if (item[createSubjectHandler_1.getUnderlyingNode]) {
        return item[createSubjectHandler_1.getUnderlyingNode];
    }
    else if (!item["@id"]) {
        return (0, data_model_1.blankNode)();
    }
    else if (typeof item["@id"] === "string") {
        return (0, data_model_1.namedNode)(contextUtil.keyToIri(item["@id"]));
    }
    else {
        return item["@id"];
    }
}
function nodeToSetKey(node) {
    if (node.termType === "NamedNode") {
        return "NamedNode".concat(node.value);
    }
    else {
        return "BlankNode".concat(node.value);
    }
}
function addObjectValueToDataset(dataset, contextUtil, key, visitedObjects, subject, predicate, value, shouldDeleteOldTriples) {
    // Get the Object Node
    var object;
    if (value == undefined) {
        dataset.deleteMatches(subject, predicate);
    }
    else if (typeof value === "string" ||
        typeof value === "boolean" ||
        typeof value === "number") {
        var datatype = contextUtil.getType(key);
        if (datatype === "@id") {
            object = (0, data_model_1.namedNode)(value.toString());
        }
        else {
            object = (0, data_model_1.literal)(value.toString(), datatype);
        }
        dataset.add((0, data_model_1.quad)(subject, predicate, object));
    }
    else {
        object = getIdNode(value, contextUtil);
        // Delete any triples if the id is the same
        if (!visitedObjects.has(nodeToSetKey(object)) &&
            !value[createSubjectHandler_1.getUnderlyingNode]) {
            dataset.deleteMatches(object, undefined, undefined);
        }
        dataset.add((0, data_model_1.quad)(subject, predicate, object));
        if (!value[createSubjectHandler_1.getUnderlyingNode]) {
            addObjectToDataset(__assign(__assign({}, value), { "@id": object }), dataset, contextUtil, visitedObjects, shouldDeleteOldTriples);
        }
    }
}
exports.addObjectValueToDataset = addObjectValueToDataset;
function addObjectToDataset(item, dataset, contextUtil, visitedObjects, shouldDeleteOldTriples) {
    var subject = getIdNode(item, contextUtil);
    if (visitedObjects.has(nodeToSetKey(subject))) {
        return;
    }
    visitedObjects.add(nodeToSetKey(subject));
    Object.entries(item).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (key === "@id") {
            return;
        }
        var predicate = (0, data_model_1.namedNode)(contextUtil.keyToIri(key));
        if (shouldDeleteOldTriples && !item[createSubjectHandler_1.getUnderlyingNode]) {
            dataset.deleteMatches(subject, predicate);
        }
        if (Array.isArray(value)) {
            value.forEach(function (valueItem) {
                addObjectValueToDataset(dataset, contextUtil, key, visitedObjects, subject, predicate, valueItem, true);
            });
        }
        else {
            addObjectValueToDataset(dataset, contextUtil, key, visitedObjects, subject, predicate, value, true);
        }
    });
}
exports.addObjectToDataset = addObjectToDataset;
